import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { removeAccess } from 'redux/modules/duck-admin';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';

import colors from 'utils/colors';
import { baseFont } from 'utils/fonts';

const Remove = styled.button`
  color: #ffffff;
  font-family: ${baseFont};
  font-size: 12px;
  letter-spacing: 0.46px;
  line-height: 15px;
  text-align: center;

  box-sizing: border-box;
  height: 22px;
  width: 75.3px;
  border: 1px solid #ffffff;
  border-radius: 2px;
  background: ${colors.action2};
  cursor: pointer;

  &:hover {
    color: ${colors.action2};
    background: ${colors.white};
    border-color: ${colors.action2};
  }
`;

class RemoveButton extends Component {
  render() {
    const { _access, history } = this.props;
    return (
      <Remove
        onClick={() => {
          this.props.removeAccess(_access, history);
        }}
      >
        Yes
      </Remove>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      removeAccess,
    },
    dispatch
  );
}

export default connect(
  null,
  mapDispatchToProps
)(RemoveButton);



// WEBPACK FOOTER //
// ./src/Admin/DeactivateUser.js